import { Booking } from "api/types";
import { usePsychologistUser } from "hooks";
import { useSlotDialogParam } from "hooks/useSlotDialogParam";
import { useUserHasRole } from "../../../../hooks/userHooks";
import { Table } from "../../../Table";
import { useBookingColumns } from "./useBookingColumns";

type Props = {
  bookings: Booking[];
};

export const PatientBookings = ({ bookings }: Props) => {
  const { data, columns } = useBookingColumns(bookings);
  const [, setSlotIdParam] = useSlotDialogParam();

  const currentUserPsychologistId =
    usePsychologistUser()?.psychologist?.psychologistId;
  const isAdmin = useUserHasRole("Admin");

  const openSlotModal = async (slotId: number | string) => {
    const treatingPsychologistId = bookings.find(
      (x) => x.slotId === slotId,
    )?.psychologistId;

    const isAdminOrTreatingPsychologist =
      isAdmin || treatingPsychologistId === currentUserPsychologistId;

    if (!isAdminOrTreatingPsychologist) {
      return;
    }

    if (typeof slotId !== "number") {
      return;
    }

    await setSlotIdParam(slotId);
  };

  return (
    <Table
      data={data}
      columns={columns}
      onRowClick={(e) => openSlotModal(e.slotId)}
    />
  );
};
